/**
 * Common Attribute names associated with inventory items, and inventory item attributes
 */
export enum AttributeName {
  Size = 'size',
  Color = 'color',
  BodyColor = 'bodyColor',
  PrintLocation = 'printLocation',
  Kind = 'kind',
  // typically used to render user-friendly labels for things
  Label = 'defaultText',

  // indicates how elements should be ordered, in relation to other objects
  Order = 'displayOrder',

  // used for color pickers to render color swatch previews
  HexColor = 'hexColor',

  // used for color swatch pickers to render texture previews for color swatches
  // this property is typically found in inventory item option attributes.
  ImageUrl = 'imageUrl',

  // used for color pickers to render color swatch previews.
  // used in categorySet.ConfigurationSet option Attributes.
  // This value is used in a similar way to imageUrl, except
  // it is called media in the configurationSet.
  Media = 'media',

  // used in the categorySet.configurationSet to annotate an attribute as being a configurable
  // field for an inventory item
  Configuration = 'configuration',

  // Greeting Cards size Attribute is misnamed cardSize creating an edge case this type accounts for
  CardSize = 'cardSize',

  /**
   * Experiences field in categorySet payload is used to determine, which inputs
   * in the product configurator form need explicit user input.
   * experiences: [
   *   { name: 'similar_products', value: false },
   *   { name: 'preview_overlay', value: 'color_picker' },
   *   { name: 'add_to_cart_guard', value: 'size' },
   *   { name: 'configuration', value: 'apparel' },
   * ],
   *
   * We need to look for this constant in said property to look for inputs.
   */
  ATCGuardExperience = 'add_to_cart_guard',
  Model = 'model',
  CaseType = 'case_type',
  FrameColor = 'frameColor',
  FrameStyle = 'frameStyle',
  MatteColor = 'matteColor',
  PaperType = 'paperType',
  HandColor = 'handColor',
  Finish = 'finish',
}

/**
 * represents the state of the product configurator's internal form component,
 * represented as a map object of key-value pairs
 * e.g.
 *
 * {
 *  "size": "xl",
 *  "color": "green"
 * }
 */
export type FormikValues = Record<string, any>;

export type DSFormChangeType = {
  values: FormikValues;
  initialValues: FormikValues;
};

export type DSFormOnChangeCallback = (
  from: DSFormChangeType,
  to: DSFormChangeType,
  excludeFromAnalytics?: boolean
) => void;
